import React from "react";
// import { Breadcrumb, Button, Space } from 'antd';
// import { ArrowLeftOutlined, ReloadOutlined } from '@ant-design/icons';

/**
 * Global Page Layout Component
 * Reusable page layout with consistent structure for all modules
 *
 * @param {string} title - Page title
 * @param {string} subtitle - Page subtitle
 * @param {Array} breadcrumbs - Breadcrumb items
 * @param {React.ReactNode} children - Page content
 * @param {Array} actions - Page action buttons
 * @param {function} onBack - Back button handler
 * @param {function} onRefresh - Refresh button handler
 * @param {boolean} showBack - Whether to show back button
 * @param {boolean} showRefresh - Whether to show refresh button
 * @param {boolean} loading - Loading state
 * @param {string} className - Additional CSS classes
 * @param {Object} ...props - Additional props
 */
const PageLayout = ({ children }) => {
  return (
    <div className={`page-layout min-h-screen bg-gray-50 `}>
      {/* Page Header */}

      {/* Page Content */}
      <div className="container px-6 py-8">
        <div className="space-y-6">{children}</div>
      </div>

      {/* <style jsx>{`
        .page-layout {
          min-height: 100vh;
        }

        .page-layout .ant-breadcrumb {
          font-size: 14px;
        }

        .page-layout .ant-breadcrumb a {
          color: #6b7280;
          text-decoration: none;
        }

        .page-layout .ant-breadcrumb a:hover {
          color: #3b82f6;
        }

        .page-layout .ant-breadcrumb .ant-breadcrumb-separator {
          color: #9ca3af;
        }

        @media (max-width: 768px) {
          .page-layout .container {
            padding-left: 16px;
            padding-right: 16px;
          }

          .page-layout .bg-white {
            padding-left: 16px;
            padding-right: 16px;
          }

          .page-layout h1 {
            font-size: 1.5rem;
          }
        }
      `}</style> */}
    </div>
  );
};

export default PageLayout;
